export const addAutoHyphen = (number, withoutAreaNum = false) => {
    const regexp = withoutAreaNum ? 
                /^(\d{3,4})(\d{4})$/g 
                : /^(\d{0,3})(\d{0,4})(\d{0,4})$/g;
    
    const formatNum = withoutAreaNum ? 
                    number.replace(/[^0-9]/g, '').replace(regexp, "$1-$2").replace(/(\-{1,2})$/g, "") 
                    : number.replace(/[^0-9]/g, '').replace(regexp, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
    return formatNum;
}
export const onlyNumber = (number) => {
    return number.replace(/[^0-9]/g, '') ;
}
